var _path, _rect, _rect2, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 34.5C20.8333 23.6384 29.6384 14.8333 40.5 14.8333C51.3616 14.8333 60.1667 23.6384 60.1667 34.5V57.1667H20.8333V34.5Z",
    fill: "#C1CCF4",
    stroke: "#C1CCF4",
    strokeWidth: 5.66667
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 54,
    width: 51,
    height: 6,
    rx: 3,
    fill: "#C1CCF4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 63,
    width: 17,
    height: 6,
    rx: 3,
    fill: "#C1CCF4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 10,
    fill: "#17C5D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.25 58C63.25 58.6904 62.6904 59.25 62 59.25C61.3096 59.25 60.75 58.6904 60.75 58C60.75 57.3096 61.3096 56.75 62 56.75C62.6904 56.75 63.25 57.3096 63.25 58Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62 61.5V66",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.21076f0e4d6fc81c52288c0d1e5618ce.svg";
export { ForwardRef as ReactComponent };